import { useStoreState } from "ezStore";
import { Select, SelectProps } from "@cofano/cck";

const ShipTrackTraceProviderSelect = ({ value, onChange }: Omit<SelectProps<string, false>, "fetchOptions">) => {
	const { settings } = useStoreState(store => store.session);

	const types = settings?.multiValues?.shipTrackTraceProviderType?.split(";") || [];

	const options = types.map(type => ({
		id: type,
		name: type,
	}));

	return (
		<Select
			value={options.find(option => option.id === value)}
			fetchOptions={options}
			onChange={option => onChange?.(option?.id ?? null, false)}
			disableSearch />
	);
};


export default ShipTrackTraceProviderSelect;
